export default "__VITE_ASSET__CAyAPVlR__"